import Utils from "../../../shared/utils";
import { TrackingPayload } from "./tracking-payload.interface";

export class InitiateCheckoutPayload implements TrackingPayload {
    constructor(
        public checkoutType: string,
        public items: { product_id: number; count: number }[],
        public currencySymbol: string,
        public total: number
    ) { }

    public toMetaFormat(): Record<string, any> {
        const currency = Utils.mapCurrencyToIsoCode(this.currencySymbol);

        return {
            content_ids: this.items.map(i => i.product_id),
            contents: this.items.map(i => ({ id: i.product_id, quantity: i.count })),
            checkout_type: this.checkoutType,
            ...(currency && { currency }),
            value: this.total,
        };
    }
}